export const RECORDER_STATE = {
  IDLE: "idle",
  INITIALIZING: "initializing",
  RECORDING: "recording",
  PAUSED: "paused",
  SUMMARIZING: "summarizing",
  COMPLETED: "completed",
  ERROR: "error",
  UNSUPPORTED: "unsupported",
};

// เปิดให้ recorder ลอยตาม route อื่นได้หรือไม่ ค่า default คือเปิดไว้
export const ENABLE_FLOATING_RECORDER =
  import.meta.env.VITE_ENABLE_PRESSCRIBE_FLOATING_RECORDER?.toLowerCase() !==
  "false";

// ระดับเสียงจะถูก normalize ให้อยู่ในช่วง 0..1 ก่อนค่อยแปลงเป็น status
// `silentMax` คือยังถือว่าไม่ได้ยินเสียง
// `lowMax` คือได้ยินเสียงแต่ยังเบา
export const AUDIO_LEVEL_THRESHOLDS = {
  silentMax: 0.04,
  lowMax: 0.18,
};

// ความถี่อัปเดต level meter บน UI
export const AUDIO_LEVEL_UPDATE_INTERVAL_MS = 50;

// ช่วง warm-up หลังเริ่มไมค์ เพื่อกันค่า level แกว่งช่วงแรก
export const AUDIO_LEVEL_WARMUP_MS = 250;

// ค้างสถานะ "กำลังฟัง.." ไว้ช่วงสั้นๆ หลังเริ่ม/กลับมาอัด
export const AUDIO_STATUS_GRACE_MS = 1000;

// หมุน MediaRecorder ทุก 5 วิ เพื่อให้ blob ย่อยยัง decode/ตรวจสอบได้ง่าย
// แต่จุดตัดอัปโหลดจริงจะไม่ยึดขอบ 5 วิ เพราะไปหา quiet-cut จาก level sample แยกอีกที
export const RECORDER_TIMESLICE_MS = 5000;

// เมื่อเสียงสะสมถึง 25 วิ จะเริ่มพิจารณาตัด 1 chunk สำหรับอัปโหลด
export const AUDIO_UPLOAD_CHUNK_TARGET_MS = 25000;

// หา quiet-cut เฉพาะช่วง 15-25 วิ เพื่อให้ chunk ยาวพอและจบใกล้ช่วงเงียบ
export const AUDIO_UPLOAD_CHUNK_CUT_WINDOW_START_MS = 15000;

// จำกัดจำนวน request upload พร้อมกัน
export const AUDIO_UPLOAD_MAX_CONCURRENCY = 3;

// หน่วงก่อนเริ่ม polling รอบแรกหลังส่ง final chunk
export const CLINICAL_NOTE_POLL_DELAY_MS = 3000;

// รอบ polling ระหว่างรอ backend สรุป clinical note
export const CLINICAL_NOTE_POLL_INTERVAL_MS = 2000;

// เวลารอ clinical note summary สูงสุดก่อนแจ้ง timeout
export const CLINICAL_NOTE_POLL_TIMEOUT_MS = 60000;
